import { template as _$template } from "solid-js/web";
import { setAttribute as _$setAttribute } from "solid-js/web";
import { setStyleProperty as _$setStyleProperty } from "solid-js/web";
import { className as _$className } from "solid-js/web";
import { effect as _$effect } from "solid-js/web";
import { insert as _$insert } from "solid-js/web";
import { createComponent as _$createComponent } from "solid-js/web";
var _tmpl$ = /*#__PURE__*/_$template(`<div class=sprite-viewer__toolbar><label>Zoom<select></select></label><label><input type=checkbox>Frame outlines</label><label>Backdrop<select><option value=dark>Dark</option><option value=light>Light`),
  _tmpl$2 = /*#__PURE__*/_$template(`<option>x`),
  _tmpl$3 = /*#__PURE__*/_$template(`<div class=sprite-viewer><div><div class=sprite-viewer__sheet><img class=sprite-viewer__sheet-image></div></div><div class=sprite-viewer__frame-grid>`),
  _tmpl$4 = /*#__PURE__*/_$template(`<div class=sprite-viewer__frame-outline>`),
  _tmpl$5 = /*#__PURE__*/_$template(`<div class=sprite-viewer__frame-cell><div class=sprite-viewer__frame-thumb></div><span class=sprite-viewer__frame-label>`);
import { createSignal, For, Show } from "solid-js";
function Toolbar(props) {
  return (() => {
    var _el$ = _tmpl$(),
      _el$2 = _el$.firstChild,
      _el$3 = _el$2.firstChild,
      _el$4 = _el$3.nextSibling,
      _el$5 = _el$2.nextSibling,
      _el$6 = _el$5.firstChild,
      _el$7 = _el$5.nextSibling,
      _el$8 = _el$7.firstChild,
      _el$9 = _el$8.nextSibling,
      _el$0 = _el$9.firstChild,
      _el$1 = _el$0.nextSibling;
    _el$4.addEventListener("change", e => props.onZoom(Number(e.currentTarget.value)));
    _$insert(_el$4, _$createComponent(For, {
      each: [1, 2, 4],
      children: z => (() => {
        var _el$10 = _tmpl$2(),
          _el$11 = _el$10.firstChild;
        _el$10.value = z;
        _$insert(_el$10, z, _el$11);
        _$effect(() => _el$10.selected = props.zoom === z);
        return _el$10;
      })()
    }));
    _el$6.addEventListener("change", e => props.onOutlines(e.currentTarget.checked));
    _el$9.addEventListener("change", e => props.onBackdrop(e.currentTarget.value));
    _$effect(_p$ => {
      var _v$ = props.backdrop === "dark",
        _v$2 = props.backdrop === "light";
      _v$ !== _p$.e && (_el$0.selected = _p$.e = _v$);
      _v$2 !== _p$.t && (_el$1.selected = _p$.t = _v$2);
      return _p$;
    }, {
      e: undefined,
      t: undefined
    });
    _$effect(() => _el$6.checked = props.outlines);
    return _el$;
  })();
}

/** Sheet view (with a toggleable frame-outline overlay) plus a per-frame thumbnail grid, for a baked `.BMP` sprite sheet. */
export function SpriteViewer(props) {
  const [zoom, setZoom] = createSignal(2);
  const [outlines, setOutlines] = createSignal(true);
  const [backdrop, setBackdrop] = createSignal("dark");
  const meta = () => props.entry.meta;
  const src = () => `/baked/${props.entry.path}`;
  return (() => {
    var _el$12 = _tmpl$3(),
      _el$13 = _el$12.firstChild,
      _el$14 = _el$13.firstChild,
      _el$15 = _el$14.firstChild,
      _el$16 = _el$13.nextSibling;
    _$insert(_el$12, _$createComponent(Toolbar, {
      get zoom() {
        return zoom();
      },
      onZoom: setZoom,
      get outlines() {
        return outlines();
      },
      onOutlines: setOutlines,
      get backdrop() {
        return backdrop();
      },
      onBackdrop: setBackdrop
    }), _el$13);
    _$insert(_el$14, _$createComponent(Show, {
      get when() {
        return outlines();
      },
      get children() {
        return _$createComponent(For, {
          get each() {
            return meta().frames;
          },
          children: frame => (() => {
            var _el$17 = _tmpl$4();
            _$effect(_p$ => {
              var _v$8 = `${frame.x * zoom()}px`,
                _v$9 = `${frame.y * zoom()}px`,
                _v$0 = `${frame.width * zoom()}px`,
                _v$1 = `${frame.height * zoom()}px`;
              _v$8 !== _p$.e && _$setStyleProperty(_el$17, "left", _p$.e = _v$8);
              _v$9 !== _p$.t && _$setStyleProperty(_el$17, "top", _p$.t = _v$9);
              _v$0 !== _p$.a && _$setStyleProperty(_el$17, "width", _p$.a = _v$0);
              _v$1 !== _p$.o && _$setStyleProperty(_el$17, "height", _p$.o = _v$1);
              return _p$;
            }, {
              e: undefined,
              t: undefined,
              a: undefined,
              o: undefined
            });
            return _el$17;
          })()
        });
      }
    }), null);
    _$insert(_el$16, _$createComponent(For, {
      get each() {
        return meta().frames;
      },
      children: frame => (() => {
        var _el$18 = _tmpl$5(),
          _el$19 = _el$18.firstChild,
          _el$20 = _el$19.nextSibling;
        _$insert(_el$20, () => frame.index);
        _$effect(_p$ => {
          var _v$10 = `Frame ${frame.index}: ${frame.width}×${frame.height}`,
            _v$11 = `${frame.width}px`,
            _v$12 = `${frame.height}px`,
            _v$13 = `url(${src()})`,
            _v$14 = `-${frame.x}px -${frame.y}px`;
          _v$10 !== _p$.e && _$setAttribute(_el$18, "title", _p$.e = _v$10);
          _v$11 !== _p$.t && _$setStyleProperty(_el$19, "width", _p$.t = _v$11);
          _v$12 !== _p$.a && _$setStyleProperty(_el$19, "height", _p$.a = _v$12);
          _v$13 !== _p$.o && _$setStyleProperty(_el$19, "background-image", _p$.o = _v$13);
          _v$14 !== _p$.i && _$setStyleProperty(_el$19, "background-position", _p$.i = _v$14);
          return _p$;
        }, {
          e: undefined,
          t: undefined,
          a: undefined,
          o: undefined,
          i: undefined
        });
        return _el$18;
      })()
    }));
    _$effect(_p$ => {
      var _v$3 = `sprite-viewer__sheet-wrap sprite-viewer__sheet-wrap--${backdrop()}`,
        _v$4 = `${meta().sheetWidth * zoom()}px`,
        _v$5 = `${meta().sheetHeight * zoom()}px`,
        _v$6 = src(),
        _v$7 = `${props.entry.id} sheet`;
      _v$3 !== _p$.e && _$className(_el$13, _p$.e = _v$3);
      _v$4 !== _p$.t && _$setStyleProperty(_el$14, "width", _p$.t = _v$4);
      _v$5 !== _p$.a && _$setStyleProperty(_el$14, "height", _p$.a = _v$5);
      _v$6 !== _p$.o && _$setAttribute(_el$15, "src", _p$.o = _v$6);
      _v$7 !== _p$.i && _$setAttribute(_el$15, "alt", _p$.i = _v$7);
      return _p$;
    }, {
      e: undefined,
      t: undefined,
      a: undefined,
      o: undefined,
      i: undefined
    });
    return _el$12;
  })();
}